<template>
  <v-navigation-drawer
    :value="isEditSidebarActive"
    temporary
    touchless
    :right="true"
    :width="$vuetify.breakpoint.smAndUp ? 450 : '100%'"
    app
    @input="(val) => $emit('update:is-edit-sidebar-active', val)"
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center mb-4">
        <span class="font-weight-semibold text-base text--primary">Actualizar</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click="$emit('update:is-edit-sidebar-active',false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>
      <v-card-text v-if="itemData">
        <booking-data
          :booking="itemData"
        />
      </v-card-text>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <!-- #### Location ############## -->
          <v-textarea
            v-model="itemData.location"
            outlined
            dense
            :rules="[validators.required]"
            :counter="100"
            label="Locación"
            placeholder="Locación"
            hide-details="auto"
            class="mb-6"
            rows="2"
          ></v-textarea>

          <!-- #### EventStatusId ############## -->
          <event-status-select
            v-model="itemData.eventStatusId"
          >
          </event-status-select>

          <!-- #### Price ############## -->
          <v-text-field
            v-model="itemData.price"
            outlined
            dense
            :rules="[validators.required, validators.decimal]"
            label="Precio"
            placeholder="Precio"
            hide-details="auto"
            type="number"
            class="mb-6"
          ></v-text-field>

          <!-- #### PromoKey ############## -->
          <v-select
            v-model="itemData.promoKey"
            label="Promo Id"
            item-text="name"
            item-value="promoKey"
            :items="promosSelectList"
            outlined
            dense
            hide-details="auto"
            class="mb-6"
          >
          </v-select>

          <v-select
            v-model="itemData.salesPerson"
            :items="usersSelectList"
            item-text="name"
            item-value="name"
            placeholder="Vendedor(a)"
            label="Vendedor(a)"
            outlined
            dense
            hide-details="auto"
            class="mb-6"
          />

          <v-select
            v-model="itemData.photographer"
            :items="usersSelectList"
            item-text="name"
            item-value="name"
            placeholder="Fotógrafo(a)"
            label="Fotógrafo(a)"
            outlined
            dense
            hide-details="auto"
            class="mb-6"
          />

          <v-btn
            color="info"
            class="me-3"
            type="submit"
          >
            Actualizar
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            type="reset"
            @click="resetItemData"
          >
            Cancelar
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mdiClose, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { required, decimal } from '@core/utils/validation'
import store from '@/store'
import useEventsList from '@/components/lists/events'
import usePromosList from '@/components/lists/promos'
import EventStatusSelect from '@/components/selects/EventStatusSelect.vue'
import BookingData from '@/components/BookingData.vue'
import useUsersList from '@/components/lists/users'

export default {
  components: { EventStatusSelect, BookingData },
  model: {
    prop: 'isEditSidebarActive',
    event: 'update:is-edit-sidebar-active',
  },
  props: {
    isEditSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const {
      eventsSelectList,
    } = useEventsList()

    const {
      promosSelectList,
    } = usePromosList()

    const {
      usersSelectList,
    } = useUsersList()

    const isEditMode = ref(false)

    const blankItemData = {
      eventKey: null,
      location: null,
      eventStatusId: null,
      price: null,
      promoKey: null,
    }

    const valid = ref(false)
    const form = ref(null)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const itemData = ref(JSON.parse(JSON.stringify(blankItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(blankItemData))
      resetForm()
      emit('update:is-edit-sidebar-active', false)
      isEditMode.value = false
    }

    const onSubmit = () => {
      if (valid.value) {
        store.dispatch('bookings/apiCall', { mode: 'Update', request: itemData.value }).then(result => {
          if (result.success) {
            emit('refetch-data')
            emit('update:is-edit-sidebar-active', false)
            resetItemData()
          }
        })
      } else {
        validate()
      }
    }

    const ShowEditDialog = key => {
      store.dispatch('bookings/apiCall', { mode: 'Select', request: { key } }).then(result => {
        if (result.success) {
          itemData.value = result.data
          emit('update:is-edit-sidebar-active', true)
        }
      })
    }

    return {
      resetItemData,
      form,
      onSubmit,
      itemData,
      valid,
      validate,
      ShowEditDialog,
      eventsSelectList,
      promosSelectList,
      usersSelectList,

      // validation
      validators: { required, decimal },
      icons: {
        mdiClose,
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
}
</script>
